export const getTextFields = (skillData: any) => [
  {
    id: "skill",
    name: "name",
    label: "Name",
    type: "text",
    placeholder: "Enter Name",
    required: true,
    capitalizedFirst: true,
    value: skillData?.name,
  },
  {
    label: "Status",
    value: skillData?.enabled === true ? "Enabled" : "Disabled",
    formField: false,
  },
  {
    label: "Industry",
    value: skillData?.industry?.name,
    formField: false,
  },
];
